import { Inject, Injectable } from "@angular/core";
import { ENVIRONMENT } from "../modules/keycloak.module";
import type { IEnvironment } from "../models/interfaces/environment.interface";
import { Observable } from "rxjs";
import { StoreResponse } from "../models/store/store-response.interface";
import { RetryHttpClient } from "./base/retryable-http.client";

@Injectable({ providedIn: "root" })
export class StoreService {
  constructor(
    private readonly httpClient: RetryHttpClient,
    @Inject(ENVIRONMENT) private readonly environment: IEnvironment
  ) {}

  getStores(): Observable<StoreResponse[]> {
    return this.httpClient.get<StoreResponse[]>(`${this.environment.BASE_URL}${this.environment.STORES["BASE"]}`);
  }

  getStore(store: string): Observable<StoreResponse> {
    return this.httpClient.get<StoreResponse>(`${this.environment.BASE_URL}${this.environment.STORES["BASE"]}/${store}`);
  }
}
